const key = (s) => (s || "").trim().toLowerCase();
const fmt = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: 1 }));

export const prevMap = (rows) => Object.fromEntries((rows || []).map((r) => [key(r.category), r.amount]));

const pct = (a, b) => (a && b != null ? ((b - a) / Math.abs(a)) * 100 : null);

const Change = ({ label, from, to, unit = "b", testid }) => {
  const p = pct(from, to);
  const tone = from === undefined || p > 0 ? "text-sky-700" : to === undefined || p < 0 ? "text-amber-700" : "text-slate-500";
  return (
    <li className="flex flex-wrap items-baseline justify-between gap-2 border-t border-border py-1.5 text-sm" data-testid={testid}>
      <span className="min-w-0 flex-1">{label}</span>
      <span className={`whitespace-nowrap font-medium ${tone}`}>
        {from === undefined ? `New: ${fmt(to)}${unit}` : to === undefined ? `Removed (was ${fmt(from)}${unit})` : `${fmt(from)}${unit} → ${fmt(to)}${unit}${p !== null ? ` (${p > 0 ? "+" : ""}${p.toFixed(1)}%)` : ""}`}
      </span>
    </li>
  );
};

const rowChanges = (before, after) => {
  const a = prevMap(before);
  const b = prevMap(after);
  const names = Object.fromEntries([...(before || []), ...(after || [])].map((r) => [key(r.category), r.category]));
  return Object.keys(names).filter((k) => a[k] !== b[k]).map((k) => ({ label: names[k], from: k in a ? a[k] : undefined, to: k in b ? b[k] : undefined }));
};

export const BudgetDiff = ({ approved, draft }) => {
  if (!approved || !draft) return null;
  const sections = [
    ["Totals", [["Total spending", approved.total_spending, draft.total_spending], ["Total revenue", approved.total_revenue, draft.total_revenue]]
      .filter(([, f, t]) => f !== t).map(([label, from, to]) => ({ label, from, to }))],
    ["Spending by category", rowChanges(approved.spending, draft.spending)],
    ["Revenue by source", rowChanges(approved.revenue, draft.revenue)],
    ["Tax rates", [["Top income tax rate", approved.top_income_tax?.rate, draft.top_income_tax?.rate], ["Company tax rate", approved.company_tax?.rate, draft.company_tax?.rate]]
      .filter(([, f, t]) => f !== t).map(([label, from, to]) => ({ label, from, to, unit: "%" }))],
  ].filter(([, rows]) => rows.length);
  return (
    <div className="rounded-xl border border-sky-200 bg-white p-3" data-testid="budget-diff">
      <p className="text-sm font-semibold">What changed since the approved budget{approved.fiscal_year !== draft.fiscal_year ? ` (${approved.fiscal_year} → ${draft.fiscal_year})` : ` (${draft.fiscal_year})`}</p>
      {sections.length === 0 ? <p className="mt-1 text-sm text-slate-500" data-testid="budget-diff-none">No differences: the draft matches the approved figures.</p> : sections.map(([title, rows]) => (
        <div key={title} className="mt-2">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{title}</p>
          <ul>{rows.map((r, i) => <Change key={r.label} {...r} testid={`budget-diff-${title.split(" ")[0].toLowerCase()}-${i}`} />)}</ul>
        </div>
      ))}
    </div>
  );
};
